export enum ReservationStatus {
  active = 'active',
  toBeDelivered = 'to_be_delivered',
  delivered = 'delivered',
  notDelivered = 'not_delivered',
  canceled = 'canceled',
  missing = 'missing'
}

export enum DatePeriodEnum {
  Week = 'week',
  Month = 'month',
  Day = 'day'
}

export enum BoarderOptOutIssue {
  HasActiveReservation
}

export enum BoarderOptInIssue {
  HasCanceledReservation
}

export enum CalendarEventKind {
  ReservationOptOut = 'reservation-opt-out'
}

export enum CalendarEventName {
  Holiday = 'holiday',
  FreeDay = 'free_day'
}

export enum InvoicePaymentStatus {
  notPaid = 'not-paid',
  fullyPaid = 'fully-paid',
  partiallyPaid = 'partially-paid',
  notDetermined = 'not-determined',
  notPayedAfterExpiration = 'not-payed-after-expiration'
}
